import { useSyncExternalStore } from 'react';

const MQ = '(max-width: 639px)';

function subscribe(cb) {
	const mql = window.matchMedia(MQ);
	mql.addEventListener('change', cb);
	return () => mql.removeEventListener('change', cb);
}

function getSnapshot() {
	return window.matchMedia(MQ).matches;
}

/**
 * Returns true when the viewport is below the sm breakpoint (< 640px).
 * Reactively updates on resize via matchMedia.
 */
export default function useIsMobile() {
	return useSyncExternalStore(subscribe, getSnapshot);
}
